/* eslint-disable max-lines-per-function */
import { Button } from 'primereact/button'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { truncate } from '../../utils/string'
import Table from '../../components/layout/Table'
import vanBangBanSaoState from '../../constant/vanBangBanSaoState'
import userProcessor from '../../processor/userProcessor'
import vanBangBanSaoProcessor from '../../processor/vanBangBanSaoProcessor'
import { setUsers } from '../../store/reducer/user'
import store from '../../store/store'
import { dateToDDMMYY } from '../../utils/date'
import ChuyenDuyetVanBangBanSao from './ChuyenDuyetVanBangBanSao'
import LichSuVanBangBanSao from './LichSuVanBangBanSao'
import PhanHoiVanBangBanSao from './PhanHoiVanBangBanSao'
import ViewBanSao from './ViewBanSao'

const VanBangBanSaoChuaDuyet = () => {
  const [datas, setDatas] = useState([])
  const [lichSuId, setLichSuId] = useState({})
  const [lichSuVisible, setLichSuVisible] = useState(false)
  const [editData, setEditData] = useState({})
  const [editDataVisible, setEditDataVisible] = useState(false)
  const [phanHoiId, setPhanHoiId] = useState(null)
  const [phanHoiVisible, setPhanHoiVisible] = useState(false)
  const [visibleChuyenDuyet, setVisibleChuyenDuyet] = useState(false)
  const [selected, setSelected] = useState([])
  const { users, info } = useSelector((state) => state.user)
  const toast = useSelector((stores) => stores.notify.toast)
  const confirm = useSelector((stores) => stores.notify.confirm)
  const toggleLichSuVisible = () => setLichSuVisible(!lichSuVisible)
  const toggleEditDataVisible = () => setEditDataVisible(!editDataVisible)
  const togglePhanHoiVisible = () => setPhanHoiVisible(!phanHoiVisible)
  const toggleChuyenDuyet = () => setVisibleChuyenDuyet(!visibleChuyenDuyet)

  const getUsers = async () => {
    const rs = await userProcessor.getByPermission('VanBangBanSaoChuaDuyet')
    store.dispatch(setUsers(rs.filter((item) => item.roleName !== 'Người nhập liệu')))
  }
  const getDatas = async () => {
    const rs = await vanBangBanSaoProcessor.getByState(vanBangBanSaoState.choDuyet)
    setDatas(rs)
  }

  useEffect(async () => {
    getDatas()
    getUsers()
  }, [])

  const save = async (data) => {
    const rs = await vanBangBanSaoProcessor.upsert(data)
    toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
    if (rs.isSuccess) toggleEditDataVisible()
  }
  const phanHoi = async (data) => {
    const submitData = { noiDung: data, vanBangBanSaoId: phanHoiId }
    const rs = await vanBangBanSaoProcessor.phanHoi(submitData)
    toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
    await getDatas()
  }
  const chuyenDuyet = async (data) => {
    const rs = await vanBangBanSaoProcessor.chuyenNguoiDuyetMany(
      selected.map((item) => {
        return { ...item, vanBang: undefined }
      }),
      data,
    )
    toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
    if (rs.isSuccess) {
      getDatas()
      setSelected([])
    }
  }
  const deleteOnClick = async (id) => {
    const rs = await vanBangBanSaoProcessor.delete(id)
    toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
    if (rs.isSuccess) getDatas()
  }
  const duyetOnClick = async (id) => {
    const rs = await vanBangBanSaoProcessor.duyet(id)
    toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
    if (rs.isSuccess) getDatas()
  }
  const duyetManyOnClick = async () => {
    if (selected.find((item) => item.nguoiDuyetId !== info.id)) {
      toast({ type: 'error', message: 'Có những bản sao bạn không phải người duyệt' })
      return
    }
    const rs = await vanBangBanSaoProcessor.duyetMany(selected)
    toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
    if (rs.isSuccess) {
      getDatas()
      setSelected([])
    }
  }

  const columnTable = [
    {
      value: 'soHieuBanChinh',
      name: 'Số hiệu cũ',
      render: (item) => item.vanBang && item.vanBang.soHieu,
    },
    { value: 'soHieu', name: 'Số hiệu mới' },
    { value: 'soVaoSo', name: 'Số vào sổ' },
    { value: 'soBan', name: 'Số bản cấp' },
    {
      value: 'ngayTao',
      name: 'Ngày tạo',
      render: (item) => {
        return dateToDDMMYY(new Date(item.ngayTao))
      },
    },
    {
      value: 'nguoiDuyetId',
      name: 'Người duyệt',
      render: (item) => {
        const user = users.find((u) => u.id === item.nguoiDuyetId)
        return user ? user.fullname : ''
      },
    },
    {
      value: 'fileDinhKem',
      name: 'File đính kèm',
      render: (data) => {
        const files = data.fileDinhKem ? data.fileDinhKem.split(',') : []
        return (
          <div className="flex flex-column">
            {files.map((item) => (
              <a href={`/${item}`} className="mb-2" download>
                {truncate(item, 20)}
              </a>
            ))}
          </div>
        )
      },
    },
    {
      value: 'chinhSuaVanBangs',
      name: 'Thông tin phản hồi',
      render: (data) => {
        return (
          <div>
            {data.phanHoiBanSaos &&
              data.phanHoiBanSaos.map((item) => (
                <p>{`[${dateToDDMMYY(new Date(item.createDate))}] ${item.user.fullname}: ${
                  item.noiDung
                }`}</p>
              ))}
          </div>
        )
      },
    },
    {
      name: 'Chức năng',
      alignHeader: 'center',
      render: (data) => {
        return (
          <div className="flex justify-content-center ">
            <div className="grid w-6rem">
              {data.nguoiDuyetId === info.id ? (
                <>
                  <div className="col-6">
                    <Button
                      icon="pi pi-check"
                      className="p-button-rounded p-button-success"
                      tooltip="Duyệt"
                      tooltipOptions={{ position: 'top' }}
                      onClick={() => {
                        confirm({
                          action: () => duyetOnClick(data.id),
                          body: `Bạn có muốn duyệt bản sao này?`,
                        })
                      }}
                    />
                  </div>
                  <div className="col-6">
                    <Button
                      icon="pi pi-comment"
                      className="p-button-rounded p-button-info"
                      tooltip="Phản hồi"
                      tooltipOptions={{ position: 'top' }}
                      onClick={() => {
                        togglePhanHoiVisible()
                        setPhanHoiId(data.id)
                      }}
                    />
                  </div>
                </>
              ) : (
                <></>
              )}
              <div className="col-6">
                <Button
                  icon="pi pi-pencil"
                  className="p-button-rounded"
                  tooltip="Sửa"
                  tooltipOptions={{ position: 'top' }}
                  onClick={() => {
                    setEditData({ ...data })
                    toggleEditDataVisible()
                  }}
                />
              </div>
              <div className="col-6">
                <Button
                  icon="pi pi-history"
                  className="p-button-rounded p-button-warning"
                  tooltip="Lịch sử cấp phát"
                  tooltipOptions={{ position: 'top' }}
                  onClick={() => {
                    setLichSuId({ id: data.vanBangId })
                    toggleLichSuVisible()
                  }}
                />
              </div>
              <div className="col-6">
                <Button
                  icon="pi pi-trash"
                  className="p-button-rounded p-button-danger"
                  tooltip="Xoá"
                  tooltipOptions={{ position: 'top' }}
                  onClick={() => {
                    confirm({
                      action: () => deleteOnClick(data.id),
                      body: `Bạn có muốn xoá bản sao này?`,
                    })
                  }}
                />
              </div>
            </div>
          </div>
        )
      },
    },
  ]

  return (
    <>
      <LichSuVanBangBanSao data={lichSuId} visible={lichSuVisible} toggle={toggleLichSuVisible} />
      <ChuyenDuyetVanBangBanSao
        visible={visibleChuyenDuyet}
        toggle={toggleChuyenDuyet}
        onSubmit={chuyenDuyet}
      />
      <ViewBanSao
        visible={editDataVisible}
        toggle={toggleEditDataVisible}
        data={editData}
        disable={['nguoiDuyetId']}
        submit={save}
        canEdit
      />
      <PhanHoiVanBangBanSao
        visible={phanHoiVisible}
        toggle={togglePhanHoiVisible}
        onSubmit={phanHoi}
      />
      <div className="flex justify-content-between">
        <h4>Danh sách văn bằng bản sao chưa duyệt</h4>
        <div className="flex">
          <div>
            <Button
              icon="pi pi-check"
              className="p-button-success mr-2"
              label="Duyệt"
              onClick={() => {
                confirm({
                  action: () => duyetManyOnClick(),
                  body: 'Bạn có muốn duyệt tất cả các bản sao đã chọn?',
                })
              }}
              disabled={!selected.length}
            />
          </div>
          <div>
            <Button
              icon="pi pi-user-plus"
              className="p-button-warning"
              label="Chuyển người duyệt"
              disabled={!selected.length}
              onClick={() => {
                toggleChuyenDuyet()
              }}
            />
          </div>
        </div>
      </div>
      <div className="card">
        <Table data={datas} column={columnTable} selected={selected} setSelected={setSelected} />
      </div>
    </>
  )
}
export default VanBangBanSaoChuaDuyet
